import { useEffect, useState, useRef } from 'react';
import { Box, Card, CardContent, useMediaQuery, Typography, Container, Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Grid, RadioGroup, FormControlLabel, Radio, FormControl, FormLabel, Checkbox, Table, TableRow, TableCell, TableHead, TableBody, TableFooter} from '@mui/material';
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import api from './api.js';
import Header from './components/Header.jsx';
import { useConfirmBackLogout } from './common/useConfirmBackLogout.js';
import BackButton from './common/BackButton.js';
import { useNavigationHistory } from "./common/navigationHistory.js";
import PdfModalViewer from './PdfModalViewer.js';
import { intValidator } from './common/validators.js';
import HamburgerMenu from './components/Hamburger.jsx';

const Comp6Sub = ({exhibitorId: propExhibitorId, isModal=false, setFormModalOpen, isCorpModal=false, selectedFormKey, changeModalOpen, setExhibitors, conRepId}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const [sameAsExhibitoro6, setSameAsExhibitoro6] = useState("different");
  const [sameAsInvoice6, setSameAsInvoice6] = useState("different");
  const [ submitErrors6, setSubmitErrors6] = useState({});

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };

  const [comp6Data, setComp6Data] = useState({
    user_6_name: "",
    user_6_department: "",
    user_6_phone: "",
    user_6_tel: "",
    invoice_company_name: "",
    invoice_user_name: "",
    invoice_email: "",
    invoice_address: "",
    invoice_zip: "",
    invoice_tel: "",
    invoice_fax: "",
    elec_total: 0,
    other_items: "",
    alfa_text: "",
    details: [
      {
        elec_item_id: null,
        number: 0,
      },
    ],
  });
  const [elecItems, setElecItems] = useState([]);
  const isMobile = useMediaQuery("(max-width:710px)");
  const updateCorporateStatus = (exhibitorId, formType, action) => {
    setExhibitors((prev) =>
      prev.map((ex) => {
        if (ex.exhibitor_id !== exhibitorId) return ex;

        if (action === 'confirm') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '確認済',
            [`${formType}_host_status`]: '確認済',
          };
        }

        if (action === 'correction') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '未確認',
            [`${formType}_host_status`]: '未確認',
            [`${formType}_exhibitor_status`]: '再提出',
          };
        }

        return ex;
      })
    );
  };

   const handleCorrection = async () => {
    try {
      const res = await api.patch('/api/forms/correction', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        corporate_type: conRepId,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'correction');

      alert('再提出に更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('再提出処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      corporate_type: conRepId,
        role: "corporate"
    });
  };

    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        corporate_type: conRepId,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'confirm');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      corporate_type: conRepId,
        role: "corporate"
    });
  };

  useEffect(() => {
    const init = async () => {
      // 1. propExhibitorId 優先
      if ((isModal || isCorpModal) && propExhibitorId) {
        setExhibitorId(propExhibitorId);
        return;
      }

      // 2. localStorage 優先
      const userData = localStorage.getItem("user");
      if (userData) {
        const parsedUser = JSON.parse(userData);
        if (parsedUser?.exhibitor_id) {
          setExhibitorId(parsedUser.exhibitor_id);
          return;
        }
      }

      // 3. localStorage ない場合 → APIから再取得
      try {
        const res = await api.get("/api/auth/me"); // ←要: サーバー側で実装
        if (res.data?.exhibitor_id) {
          setExhibitorId(res.data.exhibitor_id);
          localStorage.setItem("user", JSON.stringify(res.data));
        } else {
          console.warn("exhibitor_id が取得できません");
        }
      } catch (err) {
        console.error("ユーザー再取得エラー:", err);
      }
    };

    init();
  }, [location, isModal, isCorpModal, propExhibitorId]);
  const [notApply6, setNotApply6] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const [isHovered, setIsHovered] = useState(false);

  const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展規定', path: '/出展規定.pdf' },
      { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
      { label: '色見本', path: '/色見本.pdf' },
      { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
      { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
      { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者用追加パス', path: '/出展者用追加パス.pdf' },
      { label: '小間図面', path: '/小間図面.pdf' },
      { label: '素材集', path: '/素材集.zip' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];

  const renderMenuItems = () => (
    <div
        className="menu-item"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
    >
        <div className="menu-label">資料ダウンロード</div>
        {isHovered && (
        <div className="submenu">
            {pdfItems.map((item, index) => (
            <a key={index} href={item.path} download className="submenu-item">
                {item.label}
            </a>
            ))}
        </div>
        )}
    </div>
  );

  useEffect(() => {
        const fetchItems = async () => {
            try {
                const res = await api.get("/api/master/items");
                setElecItems(res.data || []);
            } catch (err) {
                console.error("アイテム取得エラー:", err);
            }
        };
        fetchItems();
    }, []);

  const [noticeModalOpen, setNoticeModalOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setComp6Data({ ...comp6Data, [name]: type === 'checkbox' ? checked : value });
  };

  const [loading, setLoading] = useState(false);

    const [fieldsDisabled, setFieldsDisabled] = useState(false);
    const [invFieldsDisabled, setInvFieldsDisabled] = useState(false);

    const handleSameAsExhibitor = (value) => {
        setSameAsExhibitoro6(value);

        if (value === "same") {
            // 出展者情報コピー
            setComp6Data((prev) => ({
            ...prev,
            user_6_name: mypageData.user_name || "",
            user_6_department: mypageData.department || "",
            user_6_phone: mypageData.phone_number || "",
            user_6_tel: mypageData.tel_number || "",
            }));
            setFieldsDisabled(true);
        } else if (value === "different") {
            // フィールドを空にする
            setComp6Data((prev) => ({
            ...prev,
            user_6_name: "",
            user_6_department: "",
            user_6_phone: "",
            user_6_tel: "",
            }));
            setFieldsDisabled(false);
        }
    };

    const normalizeO6Data = (raw) => ({
        ...raw,
        details: Array.isArray(raw.details) ? raw.details : [],
    });

    const user = JSON.parse(localStorage.getItem("user"));
    console.log(user)
    useEffect(() => {
        const fetchComp6Data = async () => {
            setLoading(true);
            try {
            const [resData, resStatus, resMypage] = await Promise.all([
                api.get(`/api/forms/o6/${exhibitorId}`),
                api.get(`/api/submission-status/${exhibitorId}`),
                api.get(`/api/mypage/${exhibitorId}`)
            ]);

            const o6Raw = resData.data.o6 || {};
            const status = resStatus.data?.o6_status || "";
            const mypage = resMypage.data || {};
            console.log(o6Raw)

            // notApply 状態
            if (status === "申請しない") {
                setNotApply6(true);
                setFieldsDisabled(false);
            } else {
                // データがあるかチェック
                if (Object.values(o6Raw).some(v => {
                if (Array.isArray(v)) return v.length > 0;
                return v !== "" && v !== null && v !== undefined;
                })) {
                setComp6Data(prev => ({
                    ...prev,
                    ...normalizeO6Data(o6Raw),
                }));

                // mypage と一致してるか判定
                if (
                    o6Raw.user_6_name === mypage.user_name &&
                    o6Raw.user_6_department === mypage.department &&
                    o6Raw.user_6_phone === mypage.phone_number &&
                    o6Raw.user_6_tel === mypage.tel_number
                ) {
                    setSameAsExhibitoro6("same");
                    setFieldsDisabled(true);
                } else {
                    setFieldsDisabled(false);
                }
                if (
                    o6Raw.invoice_company_name === mypage.company_name &&
                    o6Raw.invoice_user_name === mypage.user_name &&
                    o6Raw.invoice_email === mypage.email &&
                    o6Raw.invoice_address === mypage.address &&
                    o6Raw.invoice_tel === mypage.phone_number &&
                    o6Raw.invoice_zip === mypage.zip_code
                ) {
                    setSameAsInvoice6("same");
                    setInvFieldsDisabled(true);
                } else {
                    setInvFieldsDisabled(false);
                }
                } else {
                // データが空ならとりあえずフォームは編集可
                setComp6Data(normalizeO6Data(o6Raw));
                setFieldsDisabled(false);
                }
                setNotApply6(false);
            }
            } catch (err) {
            console.error("Comp6 初期化エラー:", err);
            } finally {
            setLoading(false);
            }
        };

        if (exhibitorId) {
            fetchComp6Data();
        }
        }, [exhibitorId]);

    const handleSameAsInvoice = (value) => {
        setSameAsInvoice6(value);

        if (value === "same") {
        setComp6Data((prev) => ({
            ...prev,
            invoice_company_name: mypageData.company_name || "",
            invoice_user_name: mypageData.user_name || "",
            invoice_email: mypageData.email || "",
            invoice_address: mypageData.address || "",
            invoice_zip: mypageData.zip_code || "",
            invoice_tel: mypageData.phone_number || "",
        }));
        setInvFieldsDisabled(true);
        } else if (value === "different") {
        setComp6Data((prev) => ({
            ...prev,
            invoice_company_name: "",
            invoice_user_name: "",
            invoice_email: "",
            invoice_address: "",
            invoice_zip: "",
            invoice_tel: "",
        }));
        setInvFieldsDisabled(false);
        }
    };

    const handleNoApplyChange = (checked) => {
        setNotApply6(checked);

        if (checked) {
            setComp6Data({
                user_6_name: null,
                user_6_department: null,
                user_6_phone: null,
                user_6_tel: null,
                invoice_company_name: null,
                invoice_user_name: null,
                invoice_email: null,
                invoice_address: null,
                invoice_zip: null,
                invoice_tel: null,
                invoice_fax: null,
                elec_total: null,
                other_items: null,
                alfa_text: null,
                details: [],
            });
        }
    };

    const handleParentInvoiceClick = async () => {
        setLoading(true);
        try {
        const res = await api.get(`/api/parent-invoice/${mypageData.representative_id}`);
        const data = res.data;
        setComp6Data((prev) => ({
            ...prev,
            invoice_company_name: data.company_name || "",
            invoice_user_name: data.user_name || "",
            invoice_email: data.email || "",
            invoice_address: data.address || "",
            invoice_zip: data.zip_code || "",
            invoice_tel: data.phone_number || "",
        }));
        setInvFieldsDisabled(true);
        } catch (error) {
        console.error("親出展者の請求情報取得に失敗しました:", error);
        alert("親出展者の情報を取得できませんでした。");
        } finally {
        setLoading(false);
        }
    };

  const handleCloseNotice = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    setNoticeModalOpen(false);
    setTimeout(() => {
      if (isModal) {
        setFormModalOpen(false);
      } else {
        if (user?.user_id === 0) {
          navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
        } else {
          navigate(`/mypage/${user?.mypage_id}`);
        }
      }
    }, 1000);
  };

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  const [open , setOpen] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = async () => {
    try {
      if (!exhibitorId || typeof exhibitorId !== "number") {
        console.error("exhibitorId が不正やで:", exhibitorId);
        alert("exhibitorId が不正です");
        return;
      }

      // === Comp6Sub バリデーション ===
      const submitErrors6 = {};
      if (!notApply6) {
        const hasAtLeastOne = comp6Data.details.some(d => Number(d.number) >= 1);
        if (!comp6Data.user_6_name?.trim()) submitErrors6.user_6_name = "入力してください";
        if (!comp6Data.user_6_department?.trim()) submitErrors6.user_6_department = "入力してください";
        if (!comp6Data.user_6_phone?.trim()) submitErrors6.user_6_phone = "入力してください";
        if (!comp6Data.user_6_tel?.trim()) submitErrors6.user_6_tel = "入力してください";
        if (!comp6Data.invoice_company_name?.trim()) submitErrors6.invoice_company_name = "入力してください";
        if (!comp6Data.invoice_user_name?.trim()) submitErrors6.invoice_user_name = "入力してください";
        if (!comp6Data.invoice_email?.trim()) submitErrors6.invoice_email = "入力してください";
        if (!comp6Data.invoice_address?.trim()) submitErrors6.invoice_address = "入力してください";
        if (!comp6Data.invoice_zip?.trim()) submitErrors6.invoice_zip = "入力してください";
        if (!comp6Data.invoice_tel?.trim()) submitErrors6.invoice_tel = "入力してください";
        if (!hasAtLeastOne) submitErrors6.details = "いずれかの備品の数量を1以上にしてください";
      }

      // === エラーがあれば表示して中止 ===
      if (Object.keys(submitErrors6).length > 0) {
        setSubmitErrors6(submitErrors6);
        window.scrollTo({ top: 0, behavior: "smooth" });

        const fieldDisplayNames = {
          user_6_name: "担当者名",
          user_6_department: "担当部署",
          user_6_phone: "担当者携帯",
          user_6_tel: "担当者電話",
          invoice_company_name: "請求先会社名",
          invoice_user_name: "請求先担当者名",
          invoice_email: "請求先メールアドレス",
          invoice_address: "請求先住所",
          invoice_zip: "請求先郵便番号",
          invoice_tel: "請求先電話番号",
        };
        const errorMessages = Object.entries(submitErrors6)
          .map(([key, msg]) => {
            const baseKey = key.replace(/_\d+_.*/, "");
            return `・${fieldDisplayNames[key] || fieldDisplayNames[baseKey] || key}：${msg}`;
          })
          .join("\n");

        alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
        return;
      }

      const noAp6Data = {
        user_6_name: "",
        user_6_department: "",
        user_6_phone: "",
        user_6_tel: "",
        invoice_company_name: "",
        invoice_user_name: "",
        invoice_email: "",
        invoice_address: "",
        invoice_zip: "",
        invoice_tel: "",
        invoice_fax: "",
        elec_total: null,
        other_items: "",
        alfa_text: null,
        details: []
      };

      // === サニタイズ関数 ===
      const sanitizeDetails = (details, type) => {
        if (!Array.isArray(details)) return [];
        return details
          .filter(d => {
            if (type === "100") return d.quantity_100 > 0 && d.number_100 > 0;
            if (type === "200") return d.quantity_200 > 0 && d.number_200 > 0;
            return d.elec_item_id && d.number > 0; // comp6
          })
          .map(d => ({ ...d }));
      };

      const sanitizedComp6 = {
        ...comp6Data,
        details: sanitizeDetails(comp6Data.details, "comp6")
      };

      const payload = {
        exhibitor_id: exhibitorId,
        notApply6,
        o6: notApply6 ? noAp6Data : sanitizedComp6,
      };

      console.log(payload);

      const res = await api.post("/api/o6-submit", payload);
      if (res.status === 200) {
        setNoticeModalOpen(true);
        alert("保存成功");
      } else {
        alert("保存失敗");
      }
    } catch (err) {
      console.error(err);
      alert("エラー");
    }
  };
  const remarksRef = useRef(null);

  return (
    <div>
      {!isCorpModal &&(
        <Header
          title="SDGs 子ども・ユースフェア2026 電気備品レンタル申請"
          companyName={mypageData?.company_name}
        />
      )}
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        .minput input {min-width: 25px;}
        .sm-p-none {padding: 0;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        }
        `}
       </style>
       <Container sx={{ display: 'flex' }}>
        {!isCorpModal &&(
        <>
        <Container sx={{ width: '22%', mt: 4 }} className='sm-none'>
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }} className="sm-none">
              <Box
               className={`menu-item`}
               onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #0071BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#0071bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://sdgs-aichi.com/privacy/index.html', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        <HamburgerMenu />
        </>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Box sx={{ position: 'fixed', width: '14%' }}>
              <Typography variant="h6">マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}} className='sm-p-none'>
            <Typography variant="h6" sx={{ backgroundColor: '#fff', px: 1, width: '95%', margin: 'auto'}}>電気備品レンタル申込</Typography>
            <Container sx={{width: '95%', margin: 'auto', border: '1px solid #000', borderRadius: '12px'}}>
                <Box sx={{ p: 2 }}>
                    <FormControlLabel
                    control={<Checkbox checked={notApply6} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
                    label="申請しない"
                    />
                    {!notApply6 && (
                    <Box>
                        <Typography variant="h6" gutterBottom>担当者情報</Typography>
                        <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                        <FormControl component="fieldset" sx={{ mt: 2 }}>
                            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                            <RadioGroup
                            row
                            value={sameAsExhibitoro6}
                            onChange={(e) => handleSameAsExhibitor(e.target.value)}
                            >
                            <FormControlLabel value="same" control={<Radio />} label="同じ" />
                            <FormControlLabel value="different" control={<Radio />} label="異なる" />
                            </RadioGroup>
                        </FormControl>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="氏名" name="user_6_name" value={comp6Data.user_6_name} onChange={handleChange} disabled={fieldsDisabled} /></Grid>
                            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="部署" name="user_6_department" value={comp6Data.user_6_department} onChange={handleChange} disabled={fieldsDisabled} /></Grid>
                            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="会社電話番号" name="user_6_phone" value={comp6Data.user_6_phone} onChange={handleChange} disabled={fieldsDisabled} /></Grid>
                            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="携帯電話番号" name="user_6_tel" value={comp6Data.user_6_tel} onChange={handleChange} disabled={fieldsDisabled} /></Grid>
                        </Grid>
                        <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

                        <Typography variant="h6" gutterBottom>
                        請求先情報
                        </Typography>
                        <FormControl component="fieldset">
                        <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                        <RadioGroup row value={sameAsInvoice6} onChange={(e) => handleSameAsInvoice(e.target.value)}>
                            <FormControlLabel value="same" control={<Radio />} label="同じ" />
                            <FormControlLabel value="different" control={<Radio />} label="異なる" />
                        </RadioGroup>
                        {user?.co_exhibit && sameAsInvoice6 === "different" && (
                            <Button
                            variant="outlined"
                            onClick={handleParentInvoiceClick}
                            disabled={loading}
                            style={{ marginBottom: "16px" }}
                            >
                            親出展者に請求する
                            </Button>
                        )}
                        </FormControl>
                        <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求先会社名" value={comp6Data.invoice_company_name} onChange={(e) => setComp6Data({ ...comp6Data, invoice_company_name: e.target.value })} disabled={invFieldsDisabled} /></Grid>
                            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求担当者名" value={comp6Data.invoice_user_name} onChange={(e) => setComp6Data({ ...comp6Data, invoice_user_name: e.target.value })} disabled={invFieldsDisabled} /></Grid>
                            <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求先メールアドレス" value={comp6Data.invoice_email} onChange={(e) => setComp6Data({ ...comp6Data, invoice_email: e.target.value })} disabled={invFieldsDisabled} /></Grid>
                            <Grid size={6}><TextField fullWidth label="郵便番号" value={comp6Data.invoice_zip} onChange={(e) => setComp6Data({ ...comp6Data, invoice_zip: e.target.value })} disabled={invFieldsDisabled} /></Grid>
                            <Grid size={12}><TextField fullWidth label="請求先住所" value={comp6Data.invoice_address} onChange={(e) => setComp6Data({ ...comp6Data, invoice_address: e.target.value })} disabled={invFieldsDisabled} /></Grid>
                            <Grid size={6}><TextField fullWidth label="電話番号" value={comp6Data.invoice_tel} onChange={(e) => setComp6Data({ ...comp6Data, invoice_tel: e.target.value })} disabled={invFieldsDisabled} /></Grid>
                            <Grid size={6}><TextField fullWidth label="FAX番号" value={comp6Data.invoice_fax} onChange={(e) => setComp6Data({ ...comp6Data, invoice_fax: e.target.value })} disabled={invFieldsDisabled} /></Grid>
                        </Grid>

                        <Typography variant="h6" sx={{ mt: 4 }}>電気備品一覧</Typography>
                        <Box>
                            <Button variant="outlined" onClick={() => setOpen(true)}>各種電気備品の画像を見る</Button>
                        </Box>
                        <PdfModalViewer
                            filePath="/出展規定.pdf"
                            isOpen={open}
                            onClose={() => setOpen(false)}
                            startPage={24}
                            endPage={24}
                        />
                        <Box>
                          {isMobile ? (
                            <>
                            <Button
                              variant="contained"
                              onClick={() => {
                                remarksRef.current?.scrollIntoView({
                                  behavior: "smooth",
                                });
                              }}
                              sx={{
                                position: "fixed",
                                bottom: 16,
                                right: 16,
                                zIndex: 1000,
                                borderRadius: "999px",
                              }}
                            >
                              備考へ
                            </Button>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                              {elecItems.map((item, index) => {
                                const detail = comp6Data.details.find(d => d.elec_item_id === item.elec_item_id);
                                const number = detail?.number || 0;
                                const unitTotal = item.unit_price * number;

                                const handleChangeNumber = (index) => (e) => {
                                const rawValue = e.target.value;

                                const { value, error } = intValidator({ label: "数量" })(rawValue);

                                // エラー状態を更新
                                setErrors((prev) => ({
                                    ...prev,
                                    [index]: error || "",
                                }));

                                // バリデーションNG（途中入力含む）は値を更新しない
                                if (value === null) return;

                                // ====== 値の更新処理 ======
                                const newDetails = [...comp6Data.details];
                                const itemId = elecItems[index].elec_item_id;

                                const existingIndex = newDetails.findIndex(
                                    (d) => d.elec_item_id === itemId
                                );

                                if (existingIndex !== -1) {
                                    newDetails[existingIndex].number = value;
                                } else {
                                    newDetails.push({
                                    elec_item_id: itemId,
                                    number: value,
                                    });
                                }

                                // 合計再計算
                                const newTotal = elecItems.reduce((acc, item) => {
                                    const detail = newDetails.find(
                                    (d) => d.elec_item_id === item.elec_item_id
                                    );
                                    return acc + item.unit_price * (detail?.number || 0);
                                }, 0);

                                setComp6Data({
                                    ...comp6Data,
                                    details: newDetails,
                                    elec_total: newTotal,
                                });
                                };

                                return (
                                  <Card key={item.item_id}>
                                    <CardContent>

                                      <Typography variant="caption" color="text.secondary">
                                        品番
                                      </Typography>

                                      <Typography
                                        sx={{
                                          fontFamily: "monospace",
                                          mb: 1,
                                        }}
                                      >
                                        {item.elec_item_id}
                                      </Typography>

                                      <Typography variant="caption" color="text.secondary">
                                        品名
                                      </Typography>

                                      <Typography sx={{ mb: 1 }}>
                                        {item.elec_item_name}
                                      </Typography>

                                      <Typography variant="caption" color="text.secondary">
                                        単価(税込)
                                      </Typography>

                                      <Typography sx={{ mb: 2 }}>
                                        ¥{item.unit_price.toLocaleString()}
                                      </Typography>

                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                      >
                                        数量
                                      </Typography>

                                      <TextField
                                        value={number}
                                        onChange={handleChangeNumber(index)}
                                        error={!!errors[index]}
                                        helperText={errors[index]}
                                        size="small"
                                        fullWidth
                                        inputMode="numeric"
                                        onWheel={(e) => e.target.blur()}
                                        className='minput'
                                      />

                                      <Typography variant="caption" color="text.secondary">
                                        合計
                                      </Typography>

                                      <Typography
                                        sx={{
                                          fontWeight: "bold"
                                        }}
                                      >
                                        ¥{unitTotal.toLocaleString()}
                                      </Typography>
                                    </CardContent>
                                  </Card>
                                );
                              })}

                              <Card>
                                <CardContent>
                                  <Typography variant="subtitle2">
                                    総合計金額
                                  </Typography>

                                  <Typography variant="h6">
                                    ¥{(comp6Data.elec_total ?? 0).toLocaleString()}
                                  </Typography>
                                </CardContent>
                              </Card>
                            </Box>
                            </>
                          ) : (
                            <>
                            <Table size="small">
                            <TableHead>
                                <TableRow>
                                <TableCell>品番</TableCell>
                                <TableCell>品名</TableCell>
                                <TableCell>単価(税込)</TableCell>
                                <TableCell>数量</TableCell>
                                <TableCell>合計</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {elecItems.map((item, index) => {
                                const detail = comp6Data.details.find(d => d.elec_item_id === item.elec_item_id);
                                const number = detail?.number || 0;
                                const unitTotal = item.unit_price * number;

                                const handleChangeNumber = (index) => (e) => {
                                const rawValue = e.target.value;

                                const { value, error } = intValidator({ label: "数量" })(rawValue);

                                // エラー状態を更新
                                setErrors((prev) => ({
                                    ...prev,
                                    [index]: error || "",
                                }));

                                // バリデーションNG（途中入力含む）は値を更新しない
                                if (value === null) return;

                                // ====== 値の更新処理 ======
                                const newDetails = [...comp6Data.details];
                                const itemId = elecItems[index].elec_item_id;

                                const existingIndex = newDetails.findIndex(
                                    (d) => d.elec_item_id === itemId
                                );

                                if (existingIndex !== -1) {
                                    newDetails[existingIndex].number = value;
                                } else {
                                    newDetails.push({
                                    elec_item_id: itemId,
                                    number: value,
                                    });
                                }

                                // 合計再計算
                                const newTotal = elecItems.reduce((acc, item) => {
                                    const detail = newDetails.find(
                                    (d) => d.elec_item_id === item.elec_item_id
                                    );
                                    return acc + item.unit_price * (detail?.number || 0);
                                }, 0);

                                setComp6Data({
                                    ...comp6Data,
                                    details: newDetails,
                                    elec_total: newTotal,
                                });
                                };

                                return (
                                    <TableRow key={item.elec_item_id}>
                                    <TableCell>
                                        <Typography sx={{ fontFamily: 'monospace' }}>{item.elec_item_id}</Typography>
                                    </TableCell>
                                    <TableCell>{item.elec_item_name}</TableCell>
                                    <TableCell>¥{item.unit_price.toLocaleString()}</TableCell>
                                    <TableCell>
                                        <TextField
                                        value={number}
                                        onChange={handleChangeNumber(index)}
                                        error={!!errors[index]}
                                        helperText={errors[index]}
                                        size="small"
                                        fullWidth
                                        inputMode="numeric"
                                        onWheel={(e) => e.target.blur()}
                                        className='minput'
                                        />
                                    </TableCell>
                                    <TableCell>¥{unitTotal.toLocaleString()}</TableCell>
                                    </TableRow>
                                );
                                })}
                            </TableBody>
                            <TableFooter>
                            <TableRow>
                                <TableCell colSpan={4} align="right">
                                <Typography variant="subtitle1">総合計金額:</Typography>
                                </TableCell>
                                <TableCell>
                                <Typography variant="subtitle1">
                                    ¥{(comp6Data.elec_total ?? 0).toLocaleString()}
                                </Typography>
                                </TableCell>
                            </TableRow>
                            </TableFooter>
                            </Table>
                            </>
                          )}
                        </Box>

                        <Typography sx={{ mt: 4 }} ref={remarksRef}>その他備品</Typography>
                        <Typography color='error'>上記以外の備品レンタルを行う場合はコチラにご入力ください。</Typography>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            label="その他備品"
                            name="other_items"
                            value={comp6Data.other_items}
                            onChange={handleChange}
                        />

                        <Typography variant="h6" sx={{ mt: 4 }}>備考欄</Typography>
                        <Typography color='error'>電気備品レンタル申込について補足事項等がある場合はコチラにご入力ください。</Typography>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            label="備考"
                            name="alfa_text"
                            value={comp6Data.alfa_text}
                            onChange={handleChange}
                        />
                    </Box>
                    )}
                </Box>
            </Container>
            <div style={{padding: '15px'}}></div>
            <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
              <Typography>
                【上記入力内容についてのお問い合わせ先】<br />
                SDGs 子ども・ユースフェア出展者事務局（中部経済新聞社 事業部内）<br />
                担当：佐野、三宅<br />
                TEL:052-561-5675<br />
                入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
                ※お急ぎの場合はお電話にてお問い合わせください。
              </Typography>
            </Box>
            {!isCorpModal &&(
            <Container sx={{textAlign: 'center'}}>
                <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
                    提出する
                </Button>
            </Container>
            )}
        </Container>
      </Container>
      <Dialog open={noticeModalOpen} onClose={handleCloseNotice}>
        <DialogTitle>注意事項</DialogTitle>
        <DialogContent>
          <p>
            電気・電力申込を申請する場合は、電気引き出し位置及び備品設置位置を「ブース平面図」よりご提出ください。
            {/* ※電気取り出し位置について指示がない場合は出展の手引きp.23の内容に沿って設置させていただきます。 */}
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseNotice} color="primary">
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
      {!isCorpModal &&(
      <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
      )}
      {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button
          variant="contained"
          onClick={handleCorrection}
          sx={{
            backgroundColor: "red",
            color: "white",
            "&:hover": {
              backgroundColor: "darkred",
            },
          }}
        >
          再提出
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          完了
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
  );
};

export default Comp6Sub;